/* global mainScript */
import React, { useState } from "react";
import PropTypes from "prop-types";

// desktop view - the button that appears next to each category's title
// clicking it shows/hides the locations under that category
// affects which pins we see on the map since only the selected category's pins are displayed

const MenuButton = (props) => {
	const { handleClick, isOpen, category, categoryName } = props;
	const [open, setOpen] = useState(isOpen);

	const handleOpen = () => {
		setOpen(!open);
		handleClick();
	};
	return (
		<div className="filter-bar__category__header" onClick={handleOpen}>
			<h3 className="filter-bar__category__header__title" dangerouslySetInnerHTML={{ __html: categoryName }}/>
			<button className="button-container">
				<img
					src={mainScript.assetPath + `images/svg/icons/icon-down-arrow.svg`}
					className={`button-container__icon ${open ? "open" : ""}`}
				/>
				<span className="button-container__background"></span>
			</button>
		</div>
	);
};

MenuButton.propTypes = {
	handleClick: PropTypes.func,
	isOpen: PropTypes.bool,
	category: PropTypes.string,
	categoryName: PropTypes.string,
};

export default MenuButton;
